import React from 'react';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import { Civility } from 'cpfr-common';

type CivilitySelectionProps = {
    label: string;
    name: string;
    isMandatory?: boolean;
    selectId?: string;
};

export const CivilitySelection: React.FC<CivilitySelectionProps> = ({ label, name, isMandatory = true, selectId }) => {
    const civilities: Civility[] = ['Madame', 'Monsieur'];

    const selectItems: ValidatedSelectItem[] = civilities.map((civility: Civility) => {
        return { value: civility, label: civility };
    });

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            name={name}
            testId={`test-${name}`}
            id={selectId}
            selectItems={selectItems}
            emptyByDefault
            required={isMandatory}
            isMandatory={isMandatory}
            requiredText=" *"
        />
    );
};
